import React from "react";
import InvestorLanding from "../../components/wtf-investors/InvestorLanding";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
const WtfInvestors = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Investors">
      <InvestorLanding userInfoData={userInfoData} />
    </HelmetWrapper>
  );
};

export default WtfInvestors;
